import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=644a7005&scoped=true&lang=pug"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=644a7005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a7005",
  null
  
)

export default component.exports